<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase visit-page-subtitle">Wizyty</span>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja wizyty</template>
          <template v-else>Dodawanie wizyty
            <p
              class="mt-2"
              v-if="isParamsPatientID" style="font-weight: 100">
              {{data.visit_date}}
            </p>
          </template>
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/wizyty')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button
          v-if="(data.service_types !== 'T_OUTSIDE' && data.service_types !== 'T_WITHOUT_PATIENT') && $route.params.id"
          theme="success"
          outline
          @click.prevent="handleClickNextReservation"
          class="mr-1">
          <i class="material-icons">add</i>
          Poproś o wyznaczenie kolejnego terminu
        </d-button>
      </d-col>
    </d-row>
    <visits-form-patient-popup
      v-if="data.patient_id"
      :on-close-popup="closePatientPopup"
      :is-visible="isPatientPopupVisible"
      :patient-id="data.patient_id"
      :visit-id="data.id || 0"
      :visit-form="isEdit"/>

    <visits-form-reservation
      :key="componentKeyService"
      v-if="data.patient_id !== 0"
      :close-modal="handleCloseNextReservation"
      :show-modal="showModalNextReservation"
      :visit-id="data.id"/>
    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs
          card
          ref="visit-form-tabs">
          <!-- Dane ogólne -->
          <d-tab
            :key="'tab-1-' + refreshTab"
            title="Dane ogólne"
            active>
            <d-row no-gutters class="page-header py-4 mb-2">
              <d-col col sm="9" class="text-center text-sm-left mb-4 mb-sm-0" style="display: flex">
                <div v-if="data.patient_not_present === 1 && (data.service_type !== 'T_OUTSIDE' || data.service_type !== 'T_WITHOUT_PATIENT')" class="mr-2"><i class="material-icons pt-2 text-danger" style="font-size: 2rem">report_problem</i></div>
                <h3 class="page-title" v-if="(data.service_type !== 'T_OUTSIDE' && data.service_types !== 'T_OUTSIDE') && (data.service_type !== 'T_WITHOUT_PATIENT' && data.service_types !== 'T_WITHOUT_PATIENT')">
                  {{ !isParamsPatientID ? 'Wizyta' : 'Wizyta dla:'}}
                  <span v-if="data.patient_not_present === 1" class="text-danger font-weight-light">- {{data.patient_present_message}}</span>
                  <span style="font-weight: 100">
                    {{ isParamsPatientID ? (data.name + ' ' + data.last_name) : ''}}
                  </span>
                </h3>
                <h3 class="page-title text-danger" v-if="data.service_type === 'T_OUTSIDE' && data.service_types === 'T_OUTSIDE'">
                  {{data.service_type_name}}
                </h3>
                <h3 class="page-title text-primary" v-if="data.service_type === 'T_WITHOUT_PATIENT' && data.service_types === 'T_WITHOUT_PATIENT'">
                  {{data.service_type_name}}
                </h3>
              </d-col>
            </d-row>
            <validation-observer ref="visits-form" tag="form">
              <div class="form-group">
                <validation-provider
                  name="institution_id"
                  v-slot="{ errors }">
                  <label for="institution_id">Placówka:</label>
                  <div :class="{ 'form-control': true, 'is-select': true }">
                    <v-select
                      placeholder="Wybierz placówkę"
                      :disabled="isEdit"
                      :options="allInstitutions"
                      v-model="data.institution_id"
                      :reduce="institution => institution.id"
                      label="id">
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.name }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.name }}
                        </div>
                      </template>
                    </v-select>
                  </div>
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="form-group">
                <validation-provider
                  :rules="'required'"
                  :name="'data.service_types'"
                  v-slot="{ errors }">
                  <div class="form-group">
                    <label class="title-box" :for="data.service_types">
                      Rodzaj pracy:
                    </label>
                    <div :class="{ 'form-control': true, 'is-select': true }">
                      <v-select
                        placeholder="Rodzaj usługi"
                        :options="allServiceTypes"
                        :reduce="type => type.id"
                        v-model="data.service_types"
                        label="name">
                        <template slot="option" slot-scope="option">
                          <div class="d-center">
                            {{ option.name }}
                          </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                          <div class="selected d-center">
                            {{ option.name }}
                          </div>
                        </template>
                      </v-select>
                    </div>
                  </div>
                  <div class="invalid-feedback" style="display: block; margin-top: -0.5rem;">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="form-group" v-if="data.service_types === 'T_WITHOUT_PATIENT' || data.service_types === 'T_OUTSIDE'">
                <label for="number_of_people"  class="title-box" >Liczba osób:</label>
                <validation-provider
                        name="number_of_people"
                        v-slot="{ errors }"
                >
                  <d-input
                          type="number"
                          :state="errors.length ? 'invalid' : null"
                          v-model="data.number_of_people" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="form-group" v-if="data.institution_id && data.service_types === 'T_STATIONARY'">
                <validation-provider
                  name="service_id"
                  v-slot="{ errors }">
                  <label for="service_id">Usługa:</label>
                  <filter-select
                    :key="'filter-select-service-' + keyServiceSelect"
                    v-model="data.service_id"
                    style="width: 100%;"
                    :endpoint-items="'/services/items?institution_id=' + data.institution_id"
                    :data-id="filters.service_id"
                    :duration="true"
                    :reduce="obj => obj.id"
                    :endpoint-item="'/services/item/'"
                    :placeholder="service.name ? service.name : 'Wyszukaj usługę...'"/>
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div
                v-if="data.institution_id && (data.service_types === 'T_OUTSIDE' || data.service_types === 'T_WITHOUT_PATIENT')"
                class="form-group" >
                <validation-provider
                  :name="'service_id'"
                  v-slot="{ errors }">
                    <label class="title-box" :for="data.institution_id">
                      Usługa:
                    </label>
                    <v-select
                      class="reservation-style reservation-style-select-max"
                      placeholder="Wybierz usługę"
                      :options="servicesForTypeNew"
                      v-model="data.service_id"
                      :reduce="service => service.id"
                      label="id">
                      <template #search="{attributes, events}">
                        <d-input
                          class="input-for-select"
                          :state="errors.length ? 'invalid' : null"
                          :required="!data.service_id"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.name }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.name }}
                        </div>
                      </template>
                    </v-select>
                </validation-provider>
              </div>
              <div class="form-group" v-if="data.institution_id && (data.service_id || (data.service_types === 'T_OUTSIDE' || data.service_type === 'T_WITHOUT_PATIENT'))">
                <label for="guardian_phone">
                  Czas trwania wizyty:
                </label>
                <validation-provider
                  name="duration"
                  v-slot="{ errors }">
                  <d-input
                    type="number"
                    :state="errors.length ? 'invalid' : null"
                    v-model="data.duration" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <d-card class="mb-5 p-3 mt-4" style="background-color: rgb(243 243 243);" v-if="data.service_types !== 'T_OUTSIDE' && data.service_types !== 'T_WITHOUT_PATIENT' && data.institution_id && data.service_id">
                <d-row class="border-bottom">
                  <d-col cols="6" md="6" lg="8">
                    <h4 class="page-subtitle">Dane pacjenta </h4>
                  </d-col>
                  <d-col cols="6" md="6" lg="4" class="visit-button_patient">
                    <d-button
                      v-if="isEdit && data.patient_not_present === 0 && data.service_types !== 'T_OUTSIDE' && data.service_types !== 'T_WITHOUT_PATIENT'"
                      theme="danger"
                      :disabled="data.patient_id === 0"
                      :class="[data.patient_id ? 'patient-button-active mr-2' : 'patient-button-inactive mr-2']"
                      @click.prevent="handleOpenShowUp">
                      <i class="material-icons">report_problem</i>
                      Pacjent nie pojawił się
                    </d-button>
                    <d-button
                      v-if="data.patient_id"
                      :class="[data.patient_id ? 'patient-button-active' : 'patient-button-inactive']"
                      :theme="data.patient_id ? 'info' : 'dark'"
                      @click.prevent="showPatientPopup"
                      title="Podgląd">
                      <i class="material-icons">person_search</i>
                      <span class="ml-2">Karta pacjenta</span>
                    </d-button>
                  </d-col>
                </d-row>
                <div class="form-group visit-custom-group">
                  <div class="form-group">
                    <validation-provider
                      name="parent_id"
                      class="visit-patient-box"
                      v-slot="{ errors }"
                    >
                      <label for="patient_id" class="visit-patient-box-label">Wyszukaj pacjenta:</label>
                      <patient-suggestion-filter
                        :key="'patient-suggestion-' + componentKey"
                        v-model="data.patient_id"
                        style="width: 80%;"
                        :endpoint-items="'/patients/items'"
                        :data-id="data.patient_id"
                        :reduce="obj => obj.id"
                        :endpoint-item="'/patients/item/'"
                        :placeholder="'Wybierz pacjenta z listy lub filtruj po imieniu lub nazwisku...'"
                      />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                  <div class="form-group">
                    <validation-provider
                      name="parent_id"
                      v-slot="{ errors }"
                      class="visit-patient-box"
                    >
                      <label for="name" class="visit-patient-box-label">Imię:</label>
                      <d-input
                        :disabled="isParamsPatientID"
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.name" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                  <div class="form-group">
                    <validation-provider
                      name="parent_id"
                      v-slot="{ errors }"
                      class="visit-patient-box"
                    >
                      <label for="last_name" class="visit-patient-box-label">Nazwisko:</label>
                      <d-input
                        :disabled="isParamsPatientID"
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.last_name" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                  <div class="form-group">
                    <validation-provider
                      name="parent_id"
                      v-slot="{ errors }"
                      class="visit-patient-box"
                    >
                      <label for="pesel" class="visit-patient-box-label">Pesel:</label>
                      <d-input
                        :disabled="isParamsPatientID"
                        type="number"
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.pesel" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                  <div class="form-group">
                    <validation-provider
                      name="parent_id"
                      v-slot="{ errors }"
                      class="visit-patient-box"
                    >
                      <label for="phone" class="visit-patient-box-label">Numer telefonu:</label>
                      <d-input
                        :disabled="isParamsPatientID"
                        type="number"
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.phone" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </div>
              </d-card>
              <div
                class="form-group"
                v-if="(data.name && data.duration && data.last_name && data.phone && data.pesel && data.service_id &&
                (accountPermissions.role !=='R_USER')) || (data.service_types === 'T_OUTSIDE' || data.service_types === 'T_WITHOUT_PATIENT') && data.service_id">
                <validation-provider
                  name="service_id"
                  v-slot="{ errors }">
                  <label for="service_id">
                    Specjalista:
                    <i class="material-icons info-expert-label" v-d-tooltip="'Jeśli chcesz aby system wyszukał wszystkich wolnych specjalistów dla usługi, zostaw to pole puste'">help</i>
                  </label>
                  <filter-select
                    :key="keyUserSelect"
                    v-model="data.user_id"
                    style="width: 100%;"
                    :endpoint-items="'/users/items'"
                    :data-id="filters.service_id"
                    :reduce="obj => obj.id"
                    :endpoint-item="'/users/item/'"
                    :placeholder="user.name ? (user.name + ' ' + user.last_name) : 'Dowolny specjalista'"
                    :custom-params-filter="data.service_id"
                    :custom-params-filter-two="data.institution_id"/>
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div v-if="isEdit" class="visits-edit-value">
                Wizyta w dniu: <span>{{data.date_start.slice(8, 10) + ' '}}</span>
                <span>{{data.date_start.slice(5, 7) === '01' ? 'Styczeń' : (data.date_start.slice(5, 7) === '02' ? 'Luty' : (data.date_start.slice(5, 7) === '03' ? 'Marzec' : (data.date_start.slice(5, 7) === '04' ? 'Kwiecień' : (data.date_start.slice(5, 7) === '05' ? 'Maj' : (data.date_start.slice(5, 7) === '06' ? 'Czerwiec' :
          (data.date_start.slice(5, 7) === '07' ? 'Lipiec' : (data.date_start.slice(5, 7) === '08' ? 'Sierpień' : (data.date_start.slice(5, 7) === '09' ? 'Wrzesień' : (data.date_start.slice(5, 7) === '10' ? 'Październik' : (data.date_start.slice(5, 7) === '11' ? 'Listopad' : 'Grudzień')))))))))) + ' '}}</span>
                <span>{{data.date_start.slice(0, 4)}}</span>, o godzinie: <span>{{ ' ' + data.date_start.slice(10, 16)}}</span>
              </div>
              <visits-date-of-the-visit
                :key="keyDateOfTheVisit"
                :number-of-people="data.number_of_people"
                :items-where="data.user_id === 0 ? '' : ''"
                :service-id="data.service_id"
                :user-id="data.user_id"
                :visit-date="data.visit_date"
                :institution-id="data.institution_id"
                :patient-id="data.patient_id"
                :medical-id="this.$route.params.id ? this.$route.params.id : ''"
                :data-value="data"
                :single-shift="true"
                :duration="this.data.duration"/>
            </validation-observer>
            <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>
            <d-alert
              v-if="loadError"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
          <d-tab
            :key="'tab-2-' + refreshTab"
            title="Wizyta" >
            <d-row no-gutters class="page-header py-4 mb-2">
              <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
                <h3 class="page-title">
                  Dane wizyty: <p class="mt-2" style="font-weight: 100">{{data.name + ' ' + data.last_name}}</p>
                </h3>
              </d-col>
            </d-row>
            <validation-observer ref="visits-form-info" tag="form">
              <div class="form-group visit-box">
                <label class="title-box" :for="data.interview">
                  Wywiad:
                </label>
                <validation-provider
                  :name="'interview'"
                  v-slot="{ errors }">
                  <div :class="{ 'form-control': true, 'is-select': true }">
                <textarea
                  :type="'text'"
                  :state="errors.length ? 'invalid' : null"
                  v-model="data.interview"
                ></textarea>
                  </div>
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="form-group visit-box">
                <label class="title-box" :for="data.diagnosis">
                  Diagnoza:
                </label>
                <validation-provider
                  :name="'diagnosis'"
                  v-slot="{ errors }">
                  <div :class="{ 'form-control': true, 'is-select': true }">
                <textarea
                  :type="'text'"
                  :state="errors.length ? 'invalid' : null"
                  v-model="data.diagnosis"
                ></textarea>
                  </div>
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="form-group visit-box">
                <label class="title-box" :for="data.recommendations">
                  Zalecenia:
                </label>
                <validation-provider
                  :name="'recommendations'"
                  v-slot="{ errors }">
                  <div :class="{ 'form-control': true, 'is-select': true }">
                <textarea
                  :type="'text'"
                  :state="errors.length ? 'invalid' : null"
                  v-model="data.recommendations"
                ></textarea>
                  </div>
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="form-group visit-box">
                <label class="title-box" :for="data.procedures">
                  Plan dalszego działania / Uwagi:
                </label>
                <validation-provider
                  :name="'procedures'"
                  v-slot="{ errors }">
                  <div :class="{ 'form-control': true, 'is-select': true }">
                <textarea
                  :type="'text'"
                  :state="errors.length ? 'invalid' : null"
                  v-model="data.physical_examinations"
                ></textarea>
                  </div>
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <d-col
                col
                sm="6"
                class="text-right text-sm-right d-flex justify-content-end align-items-end mt-5">
                <d-button
                  v-if="isEdit"
                  theme="success"
                  @click.prevent="submitVisit">
                  Zapisz zmiany
                </d-button>
              </d-col>
            </validation-observer>
            <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>
            <d-alert
              v-if="loadError"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
          <!-- Badania -->
          <d-tab
            title="Badania"
            :disabled="!(isEdit && this.additionalCardsEnabled)">
            <patients-form-medical
              v-if="isEdit && allDataLoaded && patientLoaded"
              ref="patients-form-medical"
              :filter-for-visit="false"
              :is-add-medical-enabled="true"
              :is-in-popup="false"
              :all-institutions="allInstitutions"
              :is-visible="$refs['visit-form-tabs'].currentTab === 2"
              :patient="patient"
              :visit-id="data.id" />
          </d-tab>
          <!-- E-Dokumenty -->
          <d-tab
            title="E-Dokumenty"
            :disabled="!(isEdit && this.additionalCardsEnabled)">
            <patients-form-documents
              v-if="isEdit && allDataLoaded && patientLoaded"
              ref="patients-form-documents"
              :filter-for-visit="false"
              :is-in-popup="false"
              :is-visible="$refs['visit-form-tabs'].currentTab === 3"
              :patient="patient"
              :visit-id="data.id" />
          </d-tab>
          <!-- Orzeczenia -->
          <d-tab
            title="Orzeczenia"
            :disabled="!(isEdit && this.additionalCardsEnabled)">
            <patients-form-decisions
              v-if="isEdit && allDataLoaded && patientLoaded"
              ref="patients-form-decisions"
              :all-institutions="allInstitutions"
              :filter-for-visit="false"
              :institution-id="data.institution_id"
              :is-in-popup="false"
              :is-visible="$refs['visit-form-tabs'].currentTab === 4"
              :patient="patient"
              :visit-id="data.id" />
          </d-tab>
          <!-- Wywiady -->
          <d-tab
            title="Wywiady"
            :disabled="!(isEdit && this.additionalCardsEnabled)">
            <patients-form-interviews
              v-if="isEdit && allDataLoaded && patientLoaded"
              ref="patients-form-interviews"
              :all-users="allUsers"
              :filter-for-visit="false"
              :is-in-popup="false"
              :is-visible="$refs['visit-form-tabs'].currentTab === 5"
              :patient="patient"
              :visit-id="data.id" />
          </d-tab>
          <!-- Wyniki diagnozy -->
          <d-tab
            title="Wyniki diagnozy"
            :disabled="!(isEdit && this.additionalCardsEnabled)">
            <patients-form-diagnosis
              v-if="isEdit && allDataLoaded && patientLoaded"
              ref="patients-form-diagnosis"
              :all-users="allUsers"
              :filter-for-visit="false"
              :is-in-popup="false"
              :is-visible="$refs['visit-form-tabs'].currentTab === 6"
              :patient="patient"
              :visit-id="data.id" />
          </d-tab>
          <!-- Opinie -->
          <d-tab
            title="Opinie"
            :disabled="!(isEdit && this.additionalCardsEnabled)">
            <patients-form-opinions
              v-if="isEdit && allDataLoaded && patientLoaded"
              ref="patients-form-opinions"
              :filter-for-visit="false"
              :all-institutions="allInstitutions"
              :is-in-popup="false"
              :is-visible="$refs['visit-form-tabs'].currentTab === 7"
              :patient="patient"
              :visit-id="data.id" />
          </d-tab>
          <d-tab
            :key="'tab-8-' + refreshTab"
            title="Dodatkowe informacje"
            :disabled="!(isEdit && data.reservation_list_id !== 0)">
            <h4 class="mb-3 pb-3 border-bottom">
              Dodatkowe informacje
            </h4>
            <validation-observer ref="reservation-more-form" tag="form">
              <div class="form-group">
                <label for="institution_id">
                  Poradnia:
                </label>
                <div :class="{ 'form-control': true, 'is-select': true }">
                  <v-select
                    :disabled="true"
                    :options="allInstitutions"
                    :reduce="institution => institution.id"
                    v-model="data.institution_id"
                    placeholder="Lista poradni"
                    :searchable="false"
                    label="name">
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.name }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.name }}
                      </div>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="form-group">
                <label for="service_id">
                  Usługa:
                </label>
                <div :class="{ 'form-control': true, 'is-select': true }">
                  <v-select
                    :disabled="true"
                    style="width: 100%;"
                    :options="servicesList"
                    :reduce="obj => obj.id"
                    v-model="data.service_id"
                    placeholder="Lista usług"
                    label="name">
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.name ? option.name : '' }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.name ? option.name : '' }}
                      </div>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="form-group">
                <label for="reason_name">
                  Powód:
                </label>
                <validation-provider
                  rules="required"
                  name="reason_name"
                  v-slot="{ errors }">
                  <d-input
                    :disabled="true"
                    :state="errors.length ? 'invalid' : null"
                    v-model="reservation.reason_name" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="form-group">
                <label for="diagnosis_name">
                  Diagnoza:
                </label>
                <validation-provider
                  rules="required"
                  name="diagnosis_name"
                  v-slot="{ errors }">
                  <d-input
                    :disabled="true"
                    :state="errors.length ? 'invalid' : null"
                    v-model="reservation.diagnosis_name" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </validation-observer>
            <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>
            <d-alert
              v-if="loadError"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
    <d-modal
      v-if="showModalThePatientDidNotShowUp"
      @close="handleCloseShowUp"
      class="showUp-modal"
      style="background-color: rgba(0,0,0,0.8)!important; width: 110%">
      <d-modal-header class="showUp-head">
        <d-modal-title
          class="showUp-title">
          <h4><i class="material-icons pt-2 text-danger" style="font-size: 4rem">report_problem</i></h4>
          Czy pacjent nie pojawił się na wizycie ?
        </d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <div class="popup-box-buttons" style="margin-top: -2rem">
          <d-button
            style="min-width: 40%;"
            theme="danger"
            class="text-nowrap ml-2 mr-2"
            @click.prevent="submitPatientNotPresent">
            Potwierdź
          </d-button>
          <d-button
            style="min-width: 40%;"
            theme="secondary"
            class="text-nowrap ml-2"
            @click.prevent="handleCloseShowUp">
            Anuluj
          </d-button>
        </div>
      </d-modal-body>
    </d-modal>
  </d-container>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import FormUtils from '@/utils/FormUtils.js';
import FilterSelect from '@/components/others/FilterSelect';
import PatientSuggestionFilter from '@/components/others/PatientSuggestionFilter';
import VisitsFormPatientPopup from './VisitsFormPatientPopup';
import VisitsDateOfTheVisit from './VisitsDateOfTheVisit';
import Vue from 'vue';
import VisitsFormReservation from '@/components/forms/Visits/VisitsFormReservation';
import PatientsFormMedical from '@/components/forms/patients/PatientsFormMedical.vue';
import PatientsFormDocuments from '@/components/forms/patients/PatientsFormDocuments.vue';
import PatientsFormDecisions from '@/components/forms/patients/PatientsFormDecisions.vue';
import PatientsFormDiagnosis from '@/components/forms/patients/PatientsFormDiagnosis.vue';
import PatientsFormOpinions from '@/components/forms/patients/PatientsFormOpinions.vue';
import PatientsFormInterviews from '@/components/forms/patients/PatientsFormInterviews.vue';

export default {
  name: 'visits-form',
  components: {
    PatientsFormInterviews,
    VisitsFormReservation,
    VisitsDateOfTheVisit,
    VisitsFormPatientPopup,
    PatientSuggestionFilter,
    FilterSelect,
    DatePicker,
    'patients-form-medical': PatientsFormMedical,
    'patients-form-documents': PatientsFormDocuments,
    'patients-form-decisions': PatientsFormDecisions,
    'patients-form-interviews': PatientsFormInterviews,
    'patients-form-diagnosis': PatientsFormDiagnosis,
    'patients-form-opinions': PatientsFormOpinions,
  },
  computed: {
    accountPermissions () {
      return this.$store.getters.getAccount
    },
    isParamsPatientID () {
      return !!this.$route.params.patientID;
    },
    allDataLoaded () {
      return this.loaded && this.allUsersLoaded && this.allInstitutionsLoaded && this.allServiceTypesLoaded;
    },
    isEdit () {
      return !!this.$route.params.id;
    },
    userData () {
      return this.$store.getters.getUserForm
    }
  },
  watch: {
    'data.institution_id': function () {
      this.checkValueForModal();
      this.keyServiceSelect += 1;
      this.keyUserSelect += 1;
      this.service_id = '';
      this.filters.service_id = 0;
    },
    'service': function (value) {
      if (value && !this.isEdit) {
        if (value.duration.length === 5) {
          this.data.duration = JSON.parse(JSON.stringify(value.duration.split(':')[0]));
        }
        if (value.duration.length === 7) {
          this.data.duration = JSON.parse(JSON.stringify((Number(value.duration.split(':')[0]) * 60) + Number(value.duration.split(':')[1])));
        }
      }
    },
    'servicesForType': function () {
      this.sortServiceForType(this.data.service_types);
    },
    'data.service_type': function (value) {
      if (value) {
        this.data.service_types = value;
        if (value === 'T_OUTSIDE' || value === 'T_WITHOUT_PATIENT') {
          this.additionalCardsEnabled = false;
        }
      }
    },
    'data.service_types': function (value) {
      if (value === 'T_OUTSIDE') {
        this.data.name = 'Wizyta';
        this.data.last_name = 'Poza placówką';
        this.data.patient_id = 0;
        this.getServicesForType();
      }
      if (value === 'T_WITHOUT_PATIENT') {
        this.data.name = 'Wizyta';
        this.data.last_name = 'Bez udziału pacjenta';
        this.data.patient_id = 0;
        this.getServicesForType();
      }
    },
    'data.patient_id': function (id) {
      this.checkValueForModal();
      if (id !== 0) {
        this.getSinglePatient(id);
      }
    },
    'data.reservation_list_id': function (id) {
      if (id) {
        if (id !== 0) {
          this.getReservation();
          this.getServicesList();
        }
      }
    },
    'data.user_id': function () {
      this.checkValueForModal();
      this.keyDateOfTheVisit += 1;
    },
    'data.pesel': function (value) {
      if (this.patient.length !== 0) {
        if (this.data.patient_id !== 0) {
          if (this.patient && value !== this.patient.pesel) {
            this.clearPatientData();
            this.componentKey += 1;
          }
        }
      }
    },
    'data.phone': function (value) {
      if (this.patient.length !== 0) {
        if (this.data.patient_id !== 0) {
          if (this.patient && value !== this.patient.phone) {
            this.clearPatientData();
            this.componentKey += 1;
          }
        }
      }
    },
    'data.name': function (value) {
      if (this.patient.length !== 0) {
        if (this.data.patient_id !== 0) {
          if (this.patient && value !== this.patient.name) {
            this.clearPatientData();
            this.componentKey += 1;
          }
        }
      }
    },
    'data.last_name': function (value) {
      if (this.patient.length !== 0) {
        if (this.data.patient_id !== 0) {
          if (this.patient && value !== this.patient.last_name) {
            this.clearPatientData();
            this.componentKey += 1;
          }
        }
      }
    },
    'data.service_id': function (value) {
      this.keyDateOfTheVisit += 1;
      this.keyUserSelect += 1;
      this.checkValueForModal();
      this.getService(value);
    },
    'data.visit_date': function () {
      this.checkValueForModal();
    },
    'patient': function () {
      setTimeout(() => {
        this.data.patient_id = this.patient.id;
        this.data.pesel = this.patient.pesel;
        this.data.name = this.patient.name;
        this.data.last_name = this.patient.last_name;
      }, 500)
    },
    'visits': function () {
      this.loadFilteredDataDecisions();
      this.getUser();
      this.getService();
    },
  },
  data () {
    return {
      additionalCardsEnabled: true,
      allInstitutions: [],
      allInstitutionsLoaded: false,
      allServiceTypes: [],
      allServiceTypesLoaded: false,
      allUsers: [],
      allUsersLoaded: false,
      componentKey: 0,
      componentKeyService: 0,
      data: {
        id: '',
        date_start: '',
        diagnosis: '',
        duration: '',
        institution_id: '',
        interview: '',
        last_name: '',
        name: '',
        number_of_people: '',
        patient_id: '',
        patient_not_present: '',
        patient_present_message: '',
        pesel: '',
        phone: '',
        physical_examinations: '',
        procedures: '',
        recommendations: '',
        reservation_list_id: '',
        service_id: '',
        service_type: '',
        service_type_name: '',
        service_types: '',
        user_id: 0,
        visit_date: '',
        waiting: 1
      },
      isPatientPopupVisible: false,
      keyDateOfTheVisit: 0,
      keyServiceSelect: 0,
      keyUserSelect: 0,
      loaded: false,
      loadError: false,
      patient: {},
      patientLoaded: false,
      refreshTab: 0,
      reservation: {
        diagnosis_name: '',
        reason_name: ''
      },
      service: [],
      services: [],
      servicesForType: [],
      servicesForTypeNew: [],
      servicesList: [],
      showModalNextReservation: false,
      showModalThePatientDidNotShowUp: false,
      textOpenModal: false,
      user: [],
      visits: [],
      filters: {
        patient_id: 0,
        doc_id: 0,
        service_id: 0
      }
    }
  },
  created () {
    new Promise(() => {
      this.userAccountGet()
    });
  },
  mounted () {
    this.loadAdditionalData();
    if (this.isParamsPatientID) {
      this.getSinglePatient(this.$route.params.patientID);
    }
    if (this.accountPermissions.role === 'R_USER') {
      this.data.user_id = this.accountPermissions.id
    }
    if (this.isEdit) {
      this.loadItemData();
      // this.getVisitsList();
    } else {
      this.loaded = true;
      this.additionalCardsEnabled = false;
    }
    if (this.isEdit && (this.data.service_types !== 'T_OUTSIDE' || this.data.service_types !== 'T_WITHOUT_PATIENT') && (this.data.service_type !== 'T_OUTSIDE' || this.data.service_type === 'T_WITHOUT_PATIENT')) {
      this.checkCards1 = true
    }
  },
  methods: {
    userAccountGet () {
      this.$store.dispatch('userAccountGet')
    },
    sortServiceForType (type) {
      const services = this.servicesForType;
      let arr = [];
      for (let i = 0; i < services.length; i++) {
        if (type === 'T_OUTSIDE') {
          if (services[i].type === 'T_OUTSIDE') {
            arr[i] = services[i]
          }
        }
        if (type === 'T_WITHOUT_PATIENT') {
          if (services[i].type === 'T_WITHOUT_PATIENT') {
            arr[i] = services[i]
          }
        }
      }
      this.servicesForTypeNew = arr.filter(n => n);
    },
    handleClickNextReservation() {
      this.showModalNextReservation = true;
      this.componentKeyService += 1;
    },
    handleCloseNextReservation() {
      this.showModalNextReservation = false;
    },
    handleOpenShowUp() {
      this.showModalThePatientDidNotShowUp = true;
    },
    handleCloseShowUp() {
      this.showModalThePatientDidNotShowUp = false;
    },
    editUser () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/users/item/' + this.data.user_id,
        outputKey: 'user',
        params: {
          pagination: false
        },
      });
    },
    getService () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/services/item/' + this.data.service_id,
        outputKey: 'service',
        params: {
          pagination: false
        },
      });
    },
    getServicesForType () {
      let where = {
        institution_id: this.data.institution_id,
      };
      FormUtils.loadAdditionalData(this, {
        endpoint: '/services/items',
        outputKey: 'servicesForType',
        params: {
          where,
          pagination: false
        }
      });
    },
    getServicesList () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/services/items',
        outputKey: 'servicesList',
        params: {
          pagination: false
        }
      });
    },
    getReservation () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/patients/reservation-list/item/' + this.data.reservation_list_id,
        outputKey: 'reservation',
        params: {
          pagination: false
        },
      });
    },
    showPatientPopup() {
      this.isPatientPopupVisible = true;
    },
    closePatientPopup() {
      this.isPatientPopupVisible = false;
    },
    getUser () {
      this.$store.dispatch('userFormGet', this.data.user_id)
    },
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/visits/item/',
        instanceFields: ['patient_id', 'user_id', 'number_of_people', 'physical_examinations', 'institution_id', 'service_id', 'date_start_visit', 'date_end_visit', 'waiting', 'date_start', 'id', 'procedures', 'diagnosis', 'recommendations', 'interview', 'reservation_list_id', 'service_type', 'service_type_name', 'patient_present_message', 'patient_not_present', 'duration'],
        loadedKey: 'loaded'
      });
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/services/types',
        outputKey: 'allServiceTypes',
        loadedKey: 'allServiceTypesLoaded'
      });

      FormUtils.loadAdditionalData(this, {
        endpoint: '/institutions/items',
        outputKey: 'allInstitutions',
        loadedKey: 'allInstitutionsLoaded',
        params: {
          pagination: false
        },
      });

      FormUtils.loadAdditionalData(this, {
        endpoint: '/users/items',
        outputKey: 'allUsers',
        loadedKey: 'allUsersLoaded',
        params: {
          pagination: false,
        }
      });
    },
    submitPatientNotPresent () {
      this.$http.post('/visits/patient-not-present/' + this.data.id).then(() => {
        this.loadItemData();
        this.handleCloseShowUp();
        this.refreshAll();
      }).catch((error) => {
        console.log(error);
        Vue.swal({
          title: 'Modyfikacja nie powiodła się. Spróbuj ponownie.',
          html: 'Spróbuj ponownie',
          type: 'warning',
          confirmButtonText: 'OK',
          buttonsStyling: true
        });
      });
    },
    submitVisit () {
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = '/visits/update/' + this.data.id;

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano wizytę',
        successText: 'Wybrana wizyta została zapisana',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacje wizyty nie powiodły się. Spróbuj ponownie.',
        successAction: () => {
          this.$router.push('/wizyty')
        }
      });
    },
    prepareFormDataToSend () {
      return {
        patient_id: this.data.patient_id,
        user_id: this.data.user_id,
        institution_id: this.data.institution_id,
        service_id: this.data.service_id,
        date_start: this.data.date_start,
        duration: this.data.duration,
        waiting: 0,
        interview: this.data.interview,
        physical_examinations: this.data.physical_examinations,
        recommendations: this.data.recommendations,
        diagnosis: this.data.diagnosis,
        procedures: this.data.procedures,
        number_of_people: this.data.number_of_people
      };
    },
    clearPatientData () {
      this.data.patient_id = 0;
      this.data.name = '';
      this.data.last_name = '';
      this.data.pesel = '';
      this.data.phone = '';
    },
    getSinglePatient (patientID) {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/patients/item/' + patientID,
        outputKey: 'patient',
        loadedKey: 'patientLoaded',
        params: {
          pagination: false
        },
        successAction: () => {
          this.data.pesel = this.patient.pesel;
          this.data.phone = this.patient.phone;
          this.data.last_name = this.patient.last_name;
          this.data.name = this.patient.name;
        }
      });
    },
    checkValueForModal () {
      if (this.data.visit_date && this.data.patient_id && this.data.service_id && this.data.institution_id) {
        this.textOpenModal = true;
      }
    },
    handleClose() {
      this.showModal = false;
      this.textOpenModal = false;
    }
  }
};
</script>

<style lang="scss">
  @import '@/assets/scss/visits-form-patient';
  .vs__dropdown-option {
    white-space: normal;
  }
  .showUp-modal {
    .modal-content {
      margin-top: 60%;
    }
  }
  .page-title {
    margin-top: 0.7rem !important;
  }
  .showUp-title {
    font-size: 1.5rem !important;
  }
  .showUp-head {
    justify-content: center;
    text-align: center;
  }
  textarea {
    width: 100%;
    border: 0;
    outline: none;
    margin-bottom: -4px;
    margin-top: 1px;
    outline: none;
    min-height: 5rem;
    &:focus {
      color: $data-secondary;
      background-color: $data-white;
      border-color: $data-green;
      box-shadow: 0 0.313rem 0.719rem rgba(0, 123, 255, 0.1), 0 0.156rem 0.125rem rgba(0, 0, 0, 0.06);
    }
  }
</style>
